var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWeb24Px = function SvgWeb24Px(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 132 105",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6667 0.166504H118.333C125.529 0.166504 131.417 6.054 131.417 13.2498V91.7498C131.417 98.9457 125.529 104.833 118.333 104.833H13.6667C6.47084 104.833 0.583344 98.9457 0.583344 91.7498L0.64876 13.2498C0.64876 6.054 6.47084 0.166504 13.6667 0.166504ZM82.3542 32.8748H13.6667V55.7707H82.3542V32.8748ZM13.6667 68.854H82.3542V91.7498H13.6667V68.854ZM95.4375 91.7498H118.333V32.8748H95.4375V91.7498Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWeb24Px);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "web_24px.f5fd188ed97791bcbeb58b0f8f94b37c.svg";